import { render, staticRenderFns } from "./AppSalutationSelect.vue?vue&type=template&id=183b75eb&scoped=true&"
import script from "./AppSalutationSelect.vue?vue&type=script&lang=js&"
export * from "./AppSalutationSelect.vue?vue&type=script&lang=js&"
import style0 from "./AppSalutationSelect.vue?vue&type=style&index=0&id=183b75eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183b75eb",
  null
  
)

export default component.exports